module.exports = __webpack_public_path__ + "img/ertiga-xl7-boostergreen-glx-arena-onix.30e1efdd.png";